import type { Item } from '../../types';
import type { ToBeReviewedItem } from './toBeReviewed/buildToBeReviewed';
import {
  aggregateToBeReviewedSummary,
  isToBeReviewedNotification,
} from './toBeReviewed/aggregateToBeReviewedSummary';
import { sortByTimestampDesc } from '../../../../../common/utils/dateTimeUtils';

/**
 * Collapse pickup-family raw items into chip cards.
 * Each pickup notification type can contribute one (or more) summary cards.
 * Today: To Be Reviewed → one summary with moreToReviewCount.
 * Future types: add a branch / aggregator here without changing chip filter logic.
 */
export const aggregatePickupNotificationsForChip = (items: Item[] = []): Item[] => {
  const toBeReviewed: ToBeReviewedItem[] = [];
  const otherPickupCards: Item[] = [];

  items.forEach((item) => {
    if (isToBeReviewedNotification(item)) {
      toBeReviewed.push(item);
      return;
    }
    otherPickupCards.push(item);
  });

  const summaryCards: Item[] = [
    ...aggregateToBeReviewedSummary(toBeReviewed),
    ...otherPickupCards,
  ];

  return sortByTimestampDesc(summaryCards, (item) => item.timestamp);
};
